import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import useUpload from './hooks/useUpload'
import Button from '../control/Button'
import UploadInput from '../component/input/UploadInput'

const UploadPlaygroundView = () => {
    const { onSubmit } = useUpload()
    const { t } = useTranslation()

    return (
        // <div>
        //     <Typography variant="h3" gutterBottom>
        //         Control: Upload
        //     </Typography>
        //     <Upload />
        // </div>

        <div>
            <Typography variant="h3" gutterBottom>
                Control: Upload
            </Typography>
            <FinalForm onSubmit={onSubmit}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Field name="files" component={UploadInput} />
                            </Grid>
                            <Grid item md={12}>
                                <Button color="primary" onClick={handleSubmit}>
                                    {t('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </FinalForm>
        </div>
    )
}

//Controller
const UploadPlayground = () => {
    return <UploadPlaygroundView />
}

export default UploadPlayground
